module.exports = __webpack_public_path__ + "static/media/Onix_gaussian2.b53a07e9.png";